import { salechannelFormToQuery as formToQuery } from './salechannelFormToQuery';
import { salechannelQueryToForm as queryToForm } from './salechannelQueryToForm';

export default { queryToForm, formToQuery };

